import { render, staticRenderFns } from "./GroupsCentralUnit.vue?vue&type=template&id=fb684dc4&"
import script from "./GroupsCentralUnit.vue?vue&type=script&lang=js&"
export * from "./GroupsCentralUnit.vue?vue&type=script&lang=js&"
import style0 from "./GroupsCentralUnit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports